import React from "react";
import { Link } from "react-router-dom";
import "./MainNavbar.css";
import Nav from "react-bootstrap/Nav";

interface Props {}

const LogedInTabs = () => {
  
  return (
    <Nav className="me-auto">
        <Nav.Link href="/search">Search</Nav.Link>
        <Nav.Link href="/garage">My Garage</Nav.Link>
        <Nav.Link href="/userProfile">Profile</Nav.Link>
    </Nav>
  );
};

export default LogedInTabs;